module.exports = __webpack_public_path__ + "media/img/frontend_application/myhosting/email-151687d87f820e062a7730f1be054de6.png";